<template>
    <div class="page">
        <div class="step">
            <div class="step-items">
                <div class="step-items1">1</div>
                <div class="step-items1-name">购买套餐</div>
            </div>
            <div class="step-items">
                <div class="step-items2">2</div>
                <div class="step-items1-name">实名激活</div>
            </div>
        </div>
        <div class="list-items" v-for="item in dataList" :key="item.id">
            <div class="top">
                <div class="top-left">{{ item.packageName ? item.packageName : item.name }}</div>
                <div class="top-right">券后<span>¥
                    {{ (item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 ) - (result.price*1) > 0 ? ((item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 ) - (result.price*1)).toFixed(2) : 0 }}
                </span></div>
            </div>
            <div class="middle">
                <div class="top-left">基础包</div>
                <div class="top-right">原价 {{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}</div>
            </div>
            <div class="bottom">
                <div class="top-left">{{item.startTime}} 至 {{ item.endTime }}</div>
                <div class="top-right">
                    <van-button type="primary" block color="#397EF5" @click="sumbit(item)">立即购买</van-button>
                </div>
            </div>
        </div>
        <div class="list-items">
            <div class="title">温馨提示</div>
            <div class="content">您正在使用的卡为预充值卡，预充值卡流量更多，价格更优惠。</div>
            <div class="content" style="padding-bottom:24px;">预充值卡系统自动订购每期流量套餐，请确保余额充足。</div>
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
export default{
    data(){
        return{
            dataList:[],
            result:{}
        }
    },
    created(){
        var params = {
            iccid: this.$store.state.iccid,
            firstPkg:'1'
        }
        wxRequest('sim/user/soldPkg', params,'get').then(res => {
            console.log(res.data)
            if(res.data.code === '200'){
                this.dataList = res.data.data.list
                this.result = res.data.data.subJuan
                this.result.isAdmin = res.data.data.isAdmin
            }
        })
    },
    methods:{
        sumbit(data){
            var params = {
                ...data,
                isAdmin:this.result.isAdmin,
                price:this.result.price || 0
            }
            if (this.result.types === 1) {
                params.secondaryId = this.result.id
            } else {
                params.primaryId = this.result.id
            }
            this.$router.push({path: '/new/order', query: {params: encodeURIComponent(JSON.stringify(params))}});
        }
    }
}
</script>
<style lang="less" scoped>
.page{
    padding-top:16px;
    background: #F4F6FA;
    height: calc(100% - 16px);
    .step{
        width:70%;
        margin:0 auto;
        display: flex;
        position: relative;
        justify-content:space-between;
        margin-bottom:22px;
        &::after{
            display: block;
            content: '';
            height:1px;
            width:80%;
            border-top:1px dashed #979797;
            position: absolute;
            top:16px;
            left:34px;
            z-index: 0;
        }
        .step-items{
            position: relative;
            z-index: 1;
        }
        .step-items1,.step-items2{
            width: 33px;
            height: 33px;
            border-radius:100%;
            text-align: center;
            line-height:33px;
            color: #fff;
            margin:0 auto;
            background: #397EF5;
        }
        .step-items2{
            background: #A8B5CA; 
        }
        .step-items1-name{
            height: 21px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 21px;
            margin-top:10px;
        }
    }
    .list-items{
        width:90%;
        margin: 0 auto 10px;
        border-radius: 10px;
        background:#fff;
        .title{
            padding:15px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #28292D;
        }
        .content{
            padding:0 14px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #63666D;
            line-height: 17px;
            text-indent: 24px;
        }
    }
    .top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:12px 13px 6px 14px;
        .top-left{
            height: 25px;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #28292D;
            line-height: 25px;
        }
        .top-right{
           color: #FF8017;
           font-size:14px;
           span{
            font-size: 18px;
            padding-left:4px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
           } 
        }
    }
    .middle{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:0px 13px 17px 14px;
        .top-left{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #28292D;
            width: 59px;
            padding:4px 0;
            padding-left:12px;
            text-align: center;
            background: #E3EDFF url('../../assets/new/newCopy/icon08.png') no-repeat 3px center;
            background-size: 12px 12px;
            border-radius: 2px;

        }
        .top-right{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #C4C4C4;
            line-height: 20px; 
            text-decoration: line-through;
        }
    }
    .bottom{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:0px 13px 14px 14px;
        .top-left{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #28292D;
            padding:6px;
            padding-left:20px;
            text-align: center;
            background: #FFF4EB url('../../assets/new/newCopy/icon09.png') no-repeat 3px center;
            background-size: 12px 12px;
            border-radius: 2px;

        }
        .top-right{
            width: 90px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #C4C4C4;
            line-height: 20px; 
            .van-button{
                height:32px;
            }
        }
    }
}
</style>